export default "__VITE_ASSET__BqIElAdW__"